import { PackCard } from '@shared/ui/pack-card/pack-card'
import { EmptyState } from '../empty-state/empty-state'
import s from './packs-list.module.scss'

export const PacksList = ({ packs, role, onLeaveReview, onOpenStudent, mapPack }) => {
    if (!packs.length) {
        return <EmptyState text={role === 'teacher' ? 'У вас пока еще не купили пакеты занятий' : 'У вас пока что нет пакетов'} />
    }

    return (
        <div className={s.wrapper}>
            {packs.map((pack) => (
                <PackCard
                    key={pack?.id}
                    role={role}
                    onLeaveReview={onLeaveReview}
                    onOpenStudent={onOpenStudent ? (studentId) => onOpenStudent(studentId) : undefined}
                    {...mapPack(pack)}
                />
            ))}
        </div>
    )
}
